import { render, staticRenderFns } from "./BlockedCashflowView.vue?vue&type=template&id=2b3fa1bb&scoped=true&"
import script from "./BlockedCashflowView.vue?vue&type=script&lang=js&"
export * from "./BlockedCashflowView.vue?vue&type=script&lang=js&"
import style0 from "./BlockedCashflowView.vue?vue&type=style&index=0&id=2b3fa1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3fa1bb",
  null
  
)

export default component.exports